import { render } from "./leftBox.vue?vue&type=template&id=2d57538b&scoped=true"
import script from "./leftBox.vue?vue&type=script&lang=js"
export * from "./leftBox.vue?vue&type=script&lang=js"

import "./leftBox.vue?vue&type=style&index=0&id=2d57538b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d57538b"]])

export default __exports__